import { HttpClientModule } from '@angular/common/http';
import { RecuperarSenhaModule } from './pages/recuperar-senha/recuperar-senha.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './pages/login/login.module';
import { HomeModule } from './pages/home/home.module';
import { ComponentsModule } from './components/components.module';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { SocialAuditModule } from './pages/social-audit/social-audit.module';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTableModule } from '@angular/material/table';
import { SessionLoginComponent } from './pages/session-login/session-login.component';
import { FormSocialAuditModule } from './pages/social-audit/form-social-audit/form-social-audit.module';
import { GeomonitoringModule } from './pages/geomonitoring/geomonitoring.module';
import { NewAnalysesModule } from './pages/analises/new-analyses/new-analyses.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DatePipe, registerLocaleData } from '@angular/common';
import { GoogleChartsModule } from 'angular-google-charts';
import { SolicitacoesModule } from './pages/safe-gis/solicitacoes/solicitacoes.module';
import { TrocarSenhaComponent } from './pages/trocar-senha/trocar-senha.component';
import { MatIconModule } from '@angular/material/icon';
import localePt from '@angular/common/locales/pt';
import { DynamicFormComponent } from './pages/processos/dynamic-form/dynamic-form.component';
import { FormBuilderComponent } from './pages/processos/form-builder/form-builder.component';
import { QuestionComponent } from './pages/processos/question/question.component';
import { OptionComponent } from './pages/processos/option/option.component';


registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    SessionLoginComponent,
    TrocarSenhaComponent,
    DynamicFormComponent,
    FormBuilderComponent,
    QuestionComponent,
    OptionComponent,
  ],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    HomeModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ComponentsModule,
    FontAwesomeModule,
    LoginModule,
    SocialAuditModule,
    RecuperarSenhaModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatTableModule,
    FormSocialAuditModule,
    GeomonitoringModule,
    NewAnalysesModule,
    GoogleChartsModule,
    SolicitacoesModule,
    MatIconModule,
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(library: FaIconLibrary) {
    library.addIcons(faCoffee);
    library.addIconPacks(fas, far);
  }
}
